import React from "react";
import "./PageHeader.css";

const PageHeader = ({ title, subtitle, accent, leftAdornment, children }) => {
  return (
    <div className="v4d-page-header v4d-page-header--enter">
      <div className="v4d-page-header-main">
        {leftAdornment && (
          <div className="v4d-page-header-left-adornment">{leftAdornment}</div>
        )}
        <div className="v4d-page-header-text">
          {accent && <span className="v4d-page-header-accent">{accent}</span>}
          <h1 className="v4d-page-header-title">{title}</h1>
          {subtitle && <p className="v4d-page-header-subtitle">{subtitle}</p>}
        </div>
      </div>
      {children && <div className="v4d-page-header-actions">{children}</div>}
    </div>
  );
};

export default PageHeader;

